import React from "react";
import {render} from "react-dom";
import {BrowserRouter as Router} from "react-router-dom";
import {applyMiddleware, createStore} from "redux";
import thunkMiddleWare from "redux-thunk";
import {Provider} from "react-redux";
import {composeWithDevTools} from "redux-devtools-extension";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import App from "./components/App";
import stores from "./stores";
import './i18n/config';

const settings = await fetch('/api/settings').then(res => res.json());
msalConfig.auth = settings.auth;
const msalInstance = new PublicClientApplication(msalConfig);

const root = document.createElement("div");
document.body.appendChild(root);
const store = createStore(stores, composeWithDevTools(applyMiddleware(thunkMiddleWare)));
render(<Provider store={store}><MsalProvider instance={msalInstance}><Router><App /></Router></MsalProvider></Provider>, root);
